import { render, staticRenderFns } from "./RecentPlay.vue?vue&type=template&id=4c4514fb&scoped=true"
import script from "./RecentPlay.vue?vue&type=script&lang=js"
export * from "./RecentPlay.vue?vue&type=script&lang=js"
import style0 from "./RecentPlay.vue?vue&type=style&index=0&id=4c4514fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4514fb",
  null
  
)

export default component.exports